import React, { useState, useEffect } from "react";
import { fetchOrderById } from "../../orders-controller/order-controller";
import PdfExportA5 from "./PdfExport";

// Remove isExchange from props since we'll check each order individually
const BatchPrint = ({ orders = [], logo, mylerzLogo }) => {
  const [detailedOrders, setDetailedOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);
        // Fetch detailed information for each order
        const detailedOrdersPromises = orders.map(order => 
          fetchOrderById(order.id)
            .catch(error => {
              console.error(`Failed to fetch details for order ${order.id}:`, error);
              // Return original order if fetch fails
              return { entet: order, line: [] };
            })
        );

        const fetchedOrders = await Promise.all(detailedOrdersPromises);
        console.log("Fetched detailed orders:", fetchedOrders);
        setDetailedOrders(fetchedOrders);
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (orders && orders.length > 0) {
      fetchOrderDetails();
    } else {
      setLoading(false);
    }
  }, [orders]);

  // If still loading, just return an empty div - the print dialog will wait
  // We don't want to print the loading message
  if (loading) {
    return <div style={{ display: "none" }}></div>;
  }

  return (
    <div className="a5-pages">
      <style dangerouslySetInnerHTML={{
        __html: `
          @page {
            size: 148mm 210mm landscape;
            margin: 200mm;
          }
          body {
            padding: 0;
            font-size: 11px;
          }
          .a5-pages {
            width: 100%;
          }
          .a5-page {
            width: 210mm;
            page-break-after: always;
            position: relative;
            box-sizing: border-box;
          }
          .a5-page:last-child {
            page-break-after: auto;
          }
          .order-sheet {
            transform-origin: center;
            transform: scale(0.98);
          }
        `
      }} />
      
      {detailedOrders.map((detailedOrder, index) => {
        // Extract the order data from the detailed response
        const order = detailedOrder.entet || detailedOrder;
        const productItems = detailedOrder.line || [];
        
        // Check each individual order's exchange status
        const orderIsExchange = 
          (order.echange === true) || // Check direct property
          (detailedOrder.entet && detailedOrder.entet.echange === true); // Check entet object if present
        
        return (
          <div 
            key={order.id || index} 
            className="a5-page"
          >
            <PdfExportA5 
              order={order}
              productItems={productItems}
              logo={logo} 
              mylerzLogo={mylerzLogo}
              isExchange={orderIsExchange} // Pass each order's individual exchange status
            />
          </div>
        );
      })}
    </div>
  );
};

export default BatchPrint;